import type { FC } from "react"
import React from "react"

import { motion, AnimatePresence } from "framer-motion"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import type { UseDesign } from "~/containers/Proposal/state/designs/use-design"

import { SaveDesignButton } from "./SaveDesignButton"
import { isLeftPanelOpenState } from "../state/view"

const StyledFloatingSave = styled(motion.div)`
  position: absolute;
  bottom: 70px;
  left: 70px;
  z-index: 99999;
  width: fit-content;
  height: fit-content;
  background: white;
  border-radius: 5px;
`

const FloatingSaveButton_Internal: FC<{ design: ReturnType<UseDesign> }> = ({
  design,
}) => {
  const isLeftPanelOpen = useRecoilValue(isLeftPanelOpenState)

  return (
    <AnimatePresence>
      {!isLeftPanelOpen && (
        <StyledFloatingSave
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
            transition: {
              delay: 1,
            },
          }}
          exit={{
            opacity: 0,
          }}
        >
          <SaveDesignButton design={design} />
        </StyledFloatingSave>
      )}
    </AnimatePresence>
  )
}

export const FloatingSaveButton = React.memo(FloatingSaveButton_Internal)
